import styled, { css } from '@emotion/native';
import React, { useState } from 'react';
import { TextInput, TextInputProps } from 'react-native-paper';
import {
  NativeSyntheticEvent,
  StyleProp,
  TextInputChangeEventData,
  TextStyle,
} from 'react-native';
import {
  borderColor,
  green,
  mint,
  placeholder,
  white,
} from '@/shared/styles/colors';
import { BaseText } from './StyledText';

interface Props extends TextInputProps {
  labelText: string;
  value: string;
  onChange: (e: NativeSyntheticEvent<TextInputChangeEventData>) => void;
  customStyles?: StyleProp<TextStyle>;
  placeholderText?: string;
  labelStyle?: StyleProp<TextStyle>;
  showLabel?: boolean;
}

const StaticInput = ({
  labelText,
  onChange,
  customStyles,
  value,
  placeholderText,
  multiline = false,
  textColor = green,
  contentStyle,
  outlineStyle,
  left,
  right,
  labelStyle,
  showLabel,
  keyboardType,
}: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <InputLabel
        isVisible={isFocused || Boolean(value) || showLabel}
        style={labelStyle}
      >
        {labelText}
      </InputLabel>
      <StyledInput
        onChange={onChange}
        style={customStyles}
        value={value}
        textColor={textColor}
        placeholder={placeholderText}
        placeholderTextColor={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        outlineStyle={[inputBorderStyle, outlineStyle]}
        mode="outlined"
        multiline={multiline}
        contentStyle={contentStyle}
        left={left}
        right={right}
        keyboardType={keyboardType}
      />
    </>
  );
};

export default StaticInput;

const StyledInput = styled(TextInput)({
  height: 50,
  width: '100%',
  justifyContent: 'center',
  paddingLeft: 10,
  backgroundColor: white,
  borderColor: borderColor,
  borderWidth: 1,
  borderRadius: 36,
});

export const InputLabel = styled(BaseText)(
  ({ isVisible = false }: { isVisible?: boolean }) => ({
    fontSize: 10,
    fontWeight: 400,
    position: 'absolute',
    top: -8,
    left: 24,
    zIndex: 1000,
    backgroundColor: white,
    display: isVisible ? 'flex' : 'none',
    letterSpacing: 0.84,
    textTransform: 'uppercase',
    paddingHorizontal: 8,
    paddingVertical: 2,
    color: green,
  }),
);

export const inputBorderStyle = css({
  borderWidth: 1,
  borderColor: mint,
  borderRadius: 36,
});
